import React, { useState } from 'react';
import { Icon } from '../icon/Icon';
import './Notification.scss';

interface NotificationProps {
  color: 'success' | 'error' | 'warning' | 'informational';
  staticNotification?: boolean;
  title: string;
  subtitle?: string;
  twoLine?: boolean;
}

let notificationIcon = 'checkmarkSolid';

export const Notification: React.FC<NotificationProps> = ({
  color = 'success',
  staticNotification = '',
  title,
  subtitle,
  twoLine = ''
}) => {
  if (color === 'success') {
    notificationIcon = 'checkmarkSolid';
  }
  if (color === 'error') {
    notificationIcon = 'errorSolid';
  }
  if (color === 'warning') {
    notificationIcon = 'warningSolid';
  }
  if (color === 'informational') {
    notificationIcon = 'informationSolid';
  }

  const [removeNotification, setRemoveNotification] = useState(false);
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === ' ') {
      setRemoveNotification(true);
    }
  };

  return (
    <div
      className={`ads-notification notification-${color} ${
        twoLine ? 'two-line' : ''
      } ${staticNotification ? 'static' : ''} ${
        removeNotification ? 'ads-notification__remove' : ''
      }`}
      role="alert"
      data-testid="ads-notification"
    >
      {color === 'success' ? (
        <Icon name={notificationIcon} color="ads-color-support-success" />
      ) : (
        <Icon name={notificationIcon} />
      )}
      <span className="ads-notification__title-container">
        <span className="ads-notification__title">{title}</span>
        <span className="ads-notification__subtitle">{subtitle}</span>
      </span>
      <span
        className="ads-notification__close-button ads-icon__close-lg"
        onClick={() => setRemoveNotification(true)}
        onKeyDown={handleKeyDown}
        tabIndex={0}
      >
        <Icon name="closeLg" color="ads-color-icon-02" />
      </span>
    </div>
  );
};
